import { plaintextValidator, dropdownValidator } from '../fields';

const config = { mandatory: true };

export const serviceItemConstraints = {
  name: plaintextValidator(config)
};
